import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'
import submitBtn from 'assets/submit-btn.svg'

export default makeStyles((theme: Theme) => ({
    alert: {
        marginBottom: 25,
        color: theme.colors.white,
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    inputWrapper: {
        position: 'relative',
    },
    textarea: {
        borderRadius: 4,
        borderColor: '#2c3036',
        backgroundColor: '#2c3036',
        color: theme.colors.white,
        width: '100%',
        padding: 16,
        paddingBottom: 40,
        minHeight: 120,
        marginBottom: 25,
    },
    btn: {
        width: 20,
        height: 20,
        position: 'absolute',
        bottom: 45,
        right: 10,
        backgroundImage: `url(${submitBtn})`,
        backgroundRepeat: 'no-repeat',
        border: 0,
        borderRadius: 10,
    },
}))
